import { render, staticRenderFns } from "./SithMesTpmSpindleDataTsdList.vue?vue&type=template&id=37dd9f52&"
import script from "./SithMesTpmSpindleDataTsdList.vue?vue&type=script&lang=js&"
export * from "./SithMesTpmSpindleDataTsdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports